/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import { loadDynamicScript } from "../hooks/loadScript";

export const preload = (cb?: any) => {
    loadDynamicScript(
        "https://s3.ap-south-1.amazonaws.com/io.vlinder.scripts/purecounter_vanilla.js",
        "purecounter",
        () => {
            loadDynamicScript(
                "https://s3.ap-south-1.amazonaws.com/io.vlinder.scripts/aos.js",
                "aos",
                () => {
                    loadDynamicScript(
                        "https://s3.ap-south-1.amazonaws.com/io.vlinder.scripts/bootstrap.bundle.min.js",
                        "bootstrap-landing-page",
                        () => {
                            loadDynamicScript(
                                "https://s3.ap-south-1.amazonaws.com/io.vlinder.scripts/glightbox.min.js",
                                "glightbox",
                                () => {
                                    loadDynamicScript(
                                        "https://s3.ap-south-1.amazonaws.com/io.vlinder.scripts/isotope.pkgd.min.js",
                                        "isotope",
                                        () => {
                                            loadDynamicScript(
                                                "https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.js",
                                                "swiper",
                                                () => {
                                                    loadDynamicScript(
                                                        "https://s3.ap-south-1.amazonaws.com/io.vlinder.scripts/main.js",
                                                        "vlinder-landing-page",
                                                        () => {
                                                            console.log(
                                                                "all scripts loaded"
                                                            );
                                                            cb && cb();
                                                        }
                                                    );
                                                }
                                            );
                                        }
                                    );
                                }
                            );
                        }
                    );
                }
            );
        }
    );
};
